// Import database client
import databaseClient from '../databaseClient';

// Get the current user if there is one
export async function getUser() {
    const { data, error } = await databaseClient.auth.getSession();

    // If there is an error throw it
    if (error) {
        throw error;
    }

    return data?.user ?? null;
}

// Get a listener on authChanges
export function onUserChange(callback) {
    const { data: subscription } = databaseClient.auth.onAuthStateChange(
        (_event, session) => {
            callback(session?.user ?? null);
        },
    );

    return subscription;
}

// Connect to the database
export async function login(email, password) {
    const { error } = await databaseClient.auth.signInWithPassword({
        email,
        password,
    });

    if (error) {
        throw error;
    }
}

// Disconnect from the database
export async function logout() {
    const { error } = await databaseClient.auth.signOut();

    if (error) {
        throw error;
    }
}
